<template>
  <div id="app__ernest">
    <header class="app__header__ernest">
      <div>
        <u-icon>Ù</u-icon>
      </div>
      <div>
        <div><span>Mes questionnaires</span></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div></div>
    </header>

    <section class="app__section__ernest">
      <v-card>
        <v-card-title>
          {{ $t('components.questionnaires.list.title.name') }}
          <v-spacer/>
          <v-text-field
            v-model="search"
            append-icon="search"
            :label="$t('components.questionnaires.list.search.name')"
            single-line
            hide-details
          />
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="questionnaires"
          :search="search"
        >
          <template v-slot:item.actions="{ item }">
            <div class="table__actions__buttons">

              <v-tooltip bottom content-class="app__tooltip__ernest">
                <template slot="activator" slot-scope="{ on }">
                  <router-link :to="{ name: 'questionnairePublication', params: {id: item.id}}"
                               v-on="on"
                  >
                    <div v-on="on" class="icon__google">
                      <u-icon>á</u-icon>
                    </div>
                  </router-link>
                </template>
                <span>Options du questionnaire</span>
              </v-tooltip>

              <v-tooltip bottom content-class="app__tooltip__ernest">
                <template slot="activator" slot-scope="{ on }">
                  <router-link :to="{ name: 'questionnaireDuplication', params: {id: item.id}}"
                               v-on="on"
                  >
                    <div v-on="on">
                      <u-icon>Ù</u-icon>
                    </div>
                  </router-link>
                </template>
                <span>Dupliquer de le questionnaire</span>
              </v-tooltip>

              <v-tooltip bottom v-if="!isPublished(item)" content-class="app__tooltip__ernest">
                <template slot="activator" slot-scope="{ on }">
                <span>
                  <div v-on="on" @click.stop="onActiveDialog(item)" class="icon__google">
                    <v-icon>delete</v-icon>
                  </div>
                </span>
                </template>
                <span>Supprimer le questionnaire</span>
              </v-tooltip>
            </div>
          </template>

          <template #item.label="{ item }">
            <router-link :to="{ name: 'questionnaireCreation', params: {id: item.id }}"
                         v-if="isSelectedRepository(item.repository)">
              {{ item.label }}
            </router-link>
            <span v-else class="text--disabled">
              {{ item.label }}
              <br/>(Référentiel&nbsp;: {{ getRepositoryLabel(item.repository) }})
            </span>
          </template>

          <template #item.publicationDate="{ item }">
            <v-icon v-if="!isPublished(item)" color="red">close</v-icon>
            <v-icon v-else color="green">check</v-icon>
            &nbsp;
            <span >{{ getLocalePublishedDate(item.publicationDate) }}</span>
          </template>

          <template v-slot:no-data>
            {{ $t('components.questionnaires.list.noData.name') }}
          </template>

          <template v-slot:no-results>
            {{ $t('components.questionnaires.list.noResult.name') }}
          </template>
        </v-data-table>
      </v-card>
    </section>

    <v-dialog v-model="deleteDialog.display"
              width="500"
              id="delete__dialog"
    >

      <v-card>
        <v-card-title class="font-weight-black">{{ deleteDialog.text }}</v-card-title>
        <v-card-actions>
          <v-btn color="valid" @click.stop="onDelete">
            {{ $t('components.questionnaires.list.dialog.buttons.delete.name') }}
          </v-btn>
          <v-btn color="cancel" @click.stop="onCancelDelete">
            {{ $t('components.questionnaires.list.dialog.buttons.cancel.name') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'questionnairesList',
  data () {
    return {
      deleteDialog: {
        display: false,
        text: this.$t('components.questionnaires.list.dialog.text.name')
      },
      headers: [
        {
          text: 'Nom du questionnaire',
          value: 'label'
        },
        {
          text: 'Nombre de page',
          value: 'pageNumber'
        },
        {
          text: 'Publication',
          value: 'publicationDate'
        },
        {
          text: '',
          value: 'actions',
          sortable: false
        }
      ],
      itemsSelectedToDelete: null,
      search: '',
      tooltip1: false
    }
  },
  computed: {
    ...mapGetters('Questionnaires', [
      'questionnaires'
    ]),
    ...mapGetters('Repositories', ['repositorySelected', 'repositories'])
  },
  async created () {
    await this.loadQuestionnaires()
  },
  methods: {
    ...mapActions('Questionnaires', [
      'questionnaireDeletion',
      'loadQuestionnaires'
    ]),
    getLocalePublishedDate (publicationDate) {
      return publicationDate
        ? new Date(publicationDate).toLocaleString(navigator.language)
        : ''
    },
    /**
     * @param {QuestionnaireAir} questionnaire
     * @return {Boolean}
     */
    isPublished (questionnaire) {
      return questionnaire.isPublished &&
        questionnaire.publicationTime !== null &&
        questionnaire.publicationDate !== null
    },
    onActiveDialog (questionnaire) {
      this.itemsSelectedToDelete = questionnaire
      this.deleteDialog.display = true
    },
    onCancelDelete () {
      this.itemsSelectedToDelete = null
      this.deleteDialog.display = false
    },
    onDelete () {
      this.questionnaireDeletion(this.itemsSelectedToDelete)
      this.deleteDialog.display = false
    },
    isSelectedRepository (itemRepositoryId) {
      return this.repositorySelected.id === itemRepositoryId
    },
    getRepositoryLabel (itemRepositoryId) {
      const { name } = this.repositories.find(repository => repository.id === itemRepositoryId)
      return name
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/style/styleAppErnest";
  @import "../../assets/style/styleAppTableListErnest";
  @import "../../assets/style/styleAppTooltipErnest";

  div {
    #delete__dialog {
      .v-card__actions {
        display: flex;
        justify-content: flex-end;
      }
    }

    span {
      .icon__google {
        i {
          cursor: pointer;
        }
      }
    }
  }
</style>
